// HY Story carousel: scroll-snap track that pages by the number of visible cards (arrows + dots).
if (!customElements.get('hy-story-carousel')) {
  customElements.define('hy-story-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.hy-story__track');
      if (!this.track) return;
      this.slides = Array.from(this.track.children);
      this.dots = Array.from(this.querySelectorAll('.hy-story__dot'));
      this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.page() - 1));
      this.querySelector('[data-next]').addEventListener('click', () => this.go(this.page() + 1));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));
      const schedule = () => { cancelAnimationFrame(this.raf); this.raf = requestAnimationFrame(() => this.update()); };
      this.track.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      this.update();
    }
    step() { const s = this.slides; return (s.length > 1 ? s[1].offsetLeft - s[0].offsetLeft : this.track.clientWidth) || 1; }
    perView() { return Math.max(1, Math.round((this.track.clientWidth + 16) / this.step())); }
    pages() { return Math.ceil(this.slides.length / this.perView()); }
    page() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      if (max > 0 && this.track.scrollLeft >= max - 2) return this.pages() - 1;
      return Math.round(this.track.scrollLeft / this.step() / this.perView());
    }
    go(p) {
      const page = Math.max(0, Math.min(p, this.pages() - 1));
      this.track.scrollTo({ left: page * this.perView() * this.step(), behavior: 'smooth' });
    }
    update() {
      const pages = this.pages();
      const p = Math.min(this.page(), pages - 1);
      this.classList.toggle('is-start', p <= 0);
      this.classList.toggle('is-end', p >= pages - 1);
      this.dots.forEach((dot, n) => {
        dot.hidden = n >= pages;
        dot.classList.toggle('is-active', n === p);
        if (n === p) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
      });
    }
  });
}
